import { Component, Prop, Mixins } from "vue-property-decorator";
import RightsAware from '@/lib/mixins/rights-aware';

@Component
export default class XTextarea extends Mixins(RightsAware) {

  @Prop({default: null}) readonly placeholder!: string;
  @Prop({default: null, type: String}) readonly value!: string;

  castValue(v) {
    return (v && (v.length > 0 ? v : null)) || null;
  }

  onInput(e) {
    this.$emit("input", this.castValue(e.target.value));
  }

  forward(type) {
    return (...args) => {
      this.$emit.apply(this, [type, ...args]);
    };
  }

  render() {
    return (
      <textarea value={this.value}
        placeholder={this.placeholder}
        onInput={this.onInput}
        readonly={this.isReadonly}
        onKeydown={this.forward("keydown")}
        onKeyup={this.forward("keyup")}
      />
    )
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-348dfc13/x-textarea.tsx" });